import { render } from "./ProjectionResults.vue?vue&type=template&id=e1af5546&scoped=true"
import script from "./ProjectionResults.vue?vue&type=script&lang=js"
export * from "./ProjectionResults.vue?vue&type=script&lang=js"

import "./ProjectionResults.vue?vue&type=style&index=0&id=e1af5546&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1af5546"]])

export default __exports__